import { DataTable } from '@/components/common/DataTable';
import { ColumnDef } from '@tanstack/react-table';
import { PlayerComplaint } from '@/types';
import { Button } from '@/components/ui/button';

export const complaintColumns: ColumnDef<PlayerComplaint>[] = [
  { accessorKey: 'ticketId', header: 'Ticket ID' },
  { accessorKey: 'playerId', header: 'Player ID' },
  { accessorKey: 'username', header: 'Player Name' },
  { accessorKey: 'issueType', header: 'Issue Type' },
  { accessorKey: 'chatHistory', header: 'Chat History' },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      const status = row.original.status;
      return (
        <span className={status === 'Open' ? 'text-yellow-500' : 'text-green-500'}>{status}</span>
      );
    },
  },
  {
    accessorKey: 'actions',
    header: 'Resolve',
    cell: ({ row }) => (
      <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white">
        Resolve
      </Button>
    ),
  },
];

export default function PlayerComplaints() {
  const mockData: PlayerComplaint[] = [
    {
      ticketId: 'TCK1001',
      playerId: 'USR102',
      username: 'Amit Verma',
      issueType: 'Payment',
      chatHistory: 'Payment stuck. Please help!',
      status: 'Open',
      createdAt: '2025-02-22T10:00:00Z',
    },
    {
      ticketId: 'TCK1002',
      playerId: 'USR107',
      username: 'Manish Patel',
      issueType: 'Game Issue',
      chatHistory: 'Game crashed during bet.',
      status: 'Resolved',
      createdAt: '2025-02-21T15:30:00Z',
    },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-10">
        <div>
          <h2 className="text-3xl font-bold tracking-tight">Player Support Tickets</h2>
          <p className="text-muted-foreground">
            Manage all player-raised tickets such as payment disputes, gameplay issues, and account
            problems. Includes chat history and a resolve option.
          </p>
        </div>
      </div>

      <DataTable
        data={mockData}
        columns={complaintColumns}
        enableSearch
        pageIndex={0}
        total={0}
        onPageChange={function (page: number): void {
          throw new Error('Function not implemented.');
        }}
        onPageSizeChange={function (size: number): void {
          throw new Error('Function not implemented.');
        }}
      />
    </div>
  );
}
